import axios from 'axios';

import { IS_PROD } from '@/config';

const instance = axios.create({
  baseURL: IS_PROD ? 'https://wpproxy.hostgator.com.br/' : 'https://test-wpproxy.hostgator.com.br/',
  headers: {
    'Content-Type': 'application/json',
  },
});

const cpanelProxy = {
  instance,
  get: ({ url, headers }) => instance.get(url, { headers }),
  post: ({ url, headers, data }) => instance.post(url, data, { headers }),
  delete: ({ url, headers }) => instance.delete(url, { headers }),
};

export default cpanelProxy;
